import { ErrorCodeType } from "application/models/IError";
import { IEventRepository } from "modules/events/domain/interfaces/IEventRepository";
import {
	ILoginEventParams,
	ILoginEventResponse,
} from "modules/events/domain/models/ILoginEvent";
import { GetError } from "utils/GetError";
import { getGlobalAddLog } from "Infrastructure/repositories/appInsights/AppInsights";

const addLog = getGlobalAddLog();

export const LoginEventsUseCase = async (
	eventRepository: IEventRepository,
	params: ILoginEventParams
): Promise<ILoginEventResponse | undefined> => {
	try {
		return await eventRepository.loginEvent(params);
	} catch (error) {
		addLog && addLog("[ERROR] LoginEventsUseCase", { params, error });
		GetError(
			error,
			"LoginEventsUseCase",
			"LoginEventsUseCase",
			"Falha ao logar no evento",
			ErrorCodeType.GENERAL
		);
	}
};
